/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/** later see on figma the ones */
/** Width of barrier rect */
export const barrierWidth = 100
/** Height of barrier rect */
export const barrierHeight = 50
export const barrierEditorGap = 30

/** Width of path that make the Threat or Consequence container */
export const threatConsequenceWidth = 158
/** Height of path that make the Threat or Consequence container */
export const threatConsequenceHeight = 129

/** Width of path that make the Escalation container */
export const escalationWidth = 140
/** Height of path that make the Escalation container */
export const escalationHeight = 68
export const hazardBoxWidth = 180
export const hazardBoxAspectRatio = 0.63538874
export const hazardBoxHeight = hazardBoxWidth * hazardBoxAspectRatio
export const hazardTextAreaMargin = 5
export const shadowOpacity = 0.5

/** TopEvent Radius */
export const topEventRadius = 90

export const initialThreat = -topEventRadius - 150
export const initialConsequence = topEventRadius + 150

export const THREAT_COSNEQUENCE_GAP_X = 20
export const THREAT_CONSEQUENCE_GAP_Y = 20
export const THRAT_CONSEQUENCE_START_CURVE_GAP = barrierWidth + 10
export const BARRIER_GAP_X = 6

/** Used to unfocous barriers on highlight degraded or inactive */

export const unfocusOpacity = 0.4

/* Zoom levels */

export const settingsZoomLevel = [0.25, 1.5]

export let zoomLevel0 = [0, 0.49]
export let zoomLevel1 = [0.5, 0.99]
export let zoomLevel2 = [1, 999]

export function changeZoomLevel(level0: number[], level1: number[], level2: number[]) {
    zoomLevel0 = level0
    zoomLevel1 = level1
    zoomLevel2 = level2
}

export const bowtieTheme = {
    barrierColors: {
        inactive: '#C43535',
        degraded: '#F89300',
        degraded2: '#E8B909',
        contingence: '#C77248',
        active: '#129A96',
        unknown: '#6C7A9C',
        unmonitored: '#646464'
    },
    topEvent: {
        topEventBackgroundColor: '#FFF4E4',
        pulseColor: '#E8B909',
        colorStatus: {
            accetable: '#5cb85c',
            tolerable: '#E8B909',
            intolerable: '#C43535',
            unknown: '#6C7A9C'
        }
    },
    escalation: '#F9E47F',
    threat: '#3866B1',
    consequence: '#8768A3'
}

export const PAGINATION_SIZE = 50
export const BOWTIE_BARRIER_SETTINGS = 'barrierSettings'
export const BOWTIE_BARRIER_TYPE_ICONS = 'barriertypeicons'
export const ENGINEERING_AUDIT = 'engineeringaudit'
export const BOWTIE_SETTINGS_URL = 'bowtieEditor'
export const DRA_REPORTS = 'reports'
export const DRA_ALARMS = 'alarms'
export const DRA_ALARM_GROUPS = 'alarmgroup'
export const DRA_ALARM_SETTINGS = 'alarmsettings'
export const DRA_ALARM_STATUS = 'alarmstatus'
export const DRA_ALARM_ACKNOWLEDGE = 'acknowledge'
export const DRA_ALARM_SEEN_BY = 'seen_by'
export const DRA_ALARM_GRAPH = 'events/alarmgraph'
export const DRA_ALARM_COUNT = 'events/alarmcount'
export const DRA_ALARM_TRIGGER_LOG = 'events/alarmtriggerlog'
export const BOWTIE_BASE_URL = '/services/plugin-codaf-risk-ext-bowtie'

// eslint-disable-next-line camelcase
export const Barrier_Editor_URL = (barrierID: number) => `/#/config/bowtieEditor?type=edit&tab=barriers&id=${barrierID}`
export const BOWTIE_REST_ENDPOINTS = {
    hazards: 'hazards',
    topEvents: 'topevents',
    diagrams: 'bowtietemplate',
    threats: 'threats',
    consequences: 'consequences',
    operations: 'operations',
    barriers: 'barriers',
    barrierTypes: 'barriertypes',
    barrierConfigs: 'barrierconfig',
    bowtie: 'bowties',
    criticalities: 'criticalities',
    supervisors: 'supervisors',
    // barrierMethods: 'barriermethods',  deprecated
    updateMode: 'updatemode',
    updateModeMethods: 'methods',
    assets: 'assets',
    alarp: 'alarp',
    barrierStatus: 'barrierstatus',
    systemProperty: 'systemproperty',
    normalization: 'normalization',
    barrierConfigQualitative: 'barrierconfigqualitative',
    topEventUsage: 'topEventUsage',
    riskDiagramImport: 'import/risk-diagram/upload',
    barrierImport: 'import/barrier/upload',
    bowtieAssociation: 'import/bowtie/upload',
    importBowtieStatus: 'import/bowtie/status',
    export: 'export'
}

export const REPORT_EVENTS_ENDPOINTS = {
    topEvent: 'topevents',
    threat: 'threats',
    barriers: 'barriers',
    riskAcceptanceAndRiskLevel: 'riskacceptanceandrisklevel',
    riskAcceptanceAndRiskLevelToCsv: 'riskacceptanceandriskleveltocsv',
    resourceThreatStatusEvent: 'resourcethreatstatusevent',
    resourceThreatStatusEventToCsv: 'resourcethreatstatuseventtocsv',
    resourceConsequenceStatusEvent: 'resourceconsequencestatusevent',
    resourceConsequenceStatusEventToCsv: 'resourceconsequencestatuseventtocsv',
    resourceBarrierStatusEvent: 'resourcebarrierstatusevent',
    resourceBarrierStatusEventToCsv: 'resourcebarrierstatuseventtocsv',
    resourceBarrierPFD: 'resourcebarrierpfd',
    resourceBarrierPFDToCsv: 'resourcebarrierpfdtocsv',
    manualInteractionBarrierStatus: 'manualinteractionbarrierstatus',
    manualInteractionBarrierStatusToCsv: 'manualinteractionbarrierstatustocsv',
    currentMandatoryBarrier: 'currentmandatorybarrier',
    currentMandatoryBarrierToCsv: 'currentmandatorybarriertocsv',
    resourceBarrierAnalysis: 'resourcebarrieranalysis',
    resourceBarrierAnalysisToCsv: 'resourcebarrieranalysistocsv',
    resourceBarrierAnalysisGraph: 'resourcebarrieranalysisgraph',
    resourceBarrierAnalysisGraphCsv: 'resourcebarrieranalysisgraphtocsv',
    riskAcceptanceAndRiskLevelGraph: 'riskacceptanceandrisklevelgraph',
    riskAcceptanceAndRiskLevelGraphToCsv: 'riskacceptanceandrisklevelgraphtocsv'
}

export const ENGINEERING_AUDIT_ENDPOINTS = {
    barrier: 'barrier',
    escalationFactor: 'escalation_factor',
    controlBarrier: 'control_barrier',
    topEvent: 'top_event',
    threat: 'threat',
    consequence: 'consequence'
}
export const TOP_EVENT_MAX_CHARS = 255
export const CUSTOM_STATUS_NAME_MAX_CHARS = 10

export const barrierEditorQueryStringKey = '@DRA/editor/barrier/queryparams'
